import { useAutoResizeInput } from "../../../../hooks/useAutoResizeInput";

interface TagInputProps {
  readonly tags: string[];
  readonly tagInput: string;
  readonly onTagInputChange: (value: string) => void;
  readonly onTagsChange: (tags: string[]) => void;
}

export function TagInput({
  tags,
  tagInput,
  onTagInputChange,
  onTagsChange,
}: TagInputProps) {
  const tagInputAuto = useAutoResizeInput(tagInput, 80);
  function handleAddTag() {
    const trimmed = tagInput.trim().replace(/^#+/, "");
    if (trimmed && !tags.includes(trimmed)) {
      onTagsChange([...tags, trimmed]);
      onTagInputChange("");
    }
  }

  function handleRemoveTag(tag: string) {
    onTagsChange(tags.filter((t) => t !== tag));
  }

  function handleTagKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddTag();
    }
  }

  return (
    <div className="flex items-center gap-1.5 flex-wrap min-w-0">
      {tags.map((tag) => (
        <button
          key={tag}
          type="button"
          onClick={() => handleRemoveTag(tag)}
          className="px-2 py-0.5 text-[10px] bg-accent/10 text-accent hover:bg-accent/20 rounded-full flex items-center gap-1 transition-colors max-w-48 truncate"
        >
          <span className="truncate">{tag}</span>
          <svg className="w-3 h-3 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      ))}
      <div className="flex gap-1 items-center shrink-0">
        <input
          // eslint-disable-next-line react-hooks/refs
          ref={tagInputAuto.ref}
          type="text"
          value={tagInput}
          onChange={(e) => onTagInputChange(e.target.value)}
          onKeyDown={handleTagKeyDown}
          placeholder="+ tag"
          className="px-2.5 py-1.5 text-xs bg-surface border border-border/60 rounded-md focus:outline-none focus:border-accent/60 placeholder:text-ink-faint/60 transition-all max-w-32"
          // eslint-disable-next-line react-hooks/refs
          style={tagInputAuto.style}
        />
        <button
          type="button"
          onClick={handleAddTag}
          disabled={!tagInput.trim()}
          className="shrink-0 w-7 h-7 flex items-center justify-center bg-accent text-white text-xs rounded-full hover:bg-accent/90 disabled:bg-surface-alt disabled:text-ink-muted disabled:cursor-not-allowed transition-colors"
        >
          +
        </button>
      </div>
    </div>
  );
}
